import { render, staticRenderFns } from "./ScarUpload.vue?vue&type=template&id=fa274316&scoped=true"
import script from "./ScarUpload.vue?vue&type=script&lang=js"
export * from "./ScarUpload.vue?vue&type=script&lang=js"
import style0 from "./ScarUpload.vue?vue&type=style&index=0&id=fa274316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa274316",
  null
  
)

export default component.exports